import React from 'react'

export default function Error() {
  return (
    <div className='flex justify-center items-center text-3xl text-red'>Error-404 Not Found</div>
  )
}
